/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Hashtags from '../../hashtags_v1';
import FavoriteButton from '../../favorite_button';
import ResponsiveAvatar from '../../responsive_avatar';
import PeerDmModal from '../../peer_dm/peer_dm_modal';
import mayStartConversations from '../../my_inbox/mayStartConversations';
import helper from '../../../javascript/frontend/helpers/helper';

function PrUserCard({
                      prUser,
                      updates,
                    }) {
  // Late arriving attributes to be merged in, if any
  if (updates) Object.assign(prUser, updates.attributes);
  const maxHashtags = 5;
  const [dmModalOpen, setDmModalOpen] = useState(false);
  // Only the V2 inbox uses the compose modal; with V2_MESSAGING off, keep the legacy /dm/new link.
  const v2MessagingEnabled = Boolean(window.Qwoted?.V2_MESSAGING);

  const position = prUser.current_positions && prUser.current_positions[0];
  const peerTitle = position ? `${position.title} at ${position.company}` : undefined;

  let titleHtml = null;
  if (position) {
    titleHtml = (
      <div className="card-grid-subtitle font-size-12px">
        {position.title} at&nbsp;
        <a href={position.company_path}>
          {position.company}
        </a>
      </div>
    );
  }

  return (
    <div className="card h-100 pr-user-card animated faster fadeIn">
      <div className="card-body position-relative">
        <ResponsiveAvatar
          avatarUrl={prUser.avatar_url}
          avatarLetters={prUser.initials}
          className="mb-2"
        />

        <a href={prUser.pr_user_path} className="font-weight-bold cursor-pointer">
          {prUser.full_name}
        </a>

        <div className="mb-2">
          {titleHtml}
        </div>

        <Hashtags
          hashtagTarget={prUser}
          maxHashtags={maxHashtags}
          title={null}
          clickEventName="PrUsers/PrUserCard#clickHashtag"
        />

        {prUser.companies && (
          <div className="mb-2">
            Representing: <span dangerouslySetInnerHTML={{ __html: helper.sanitize(prUser.companies) }} />
          </div>
        )}

        <div className="clearfix" style={{ minHeight: '2.0rem' }} />
        <div className="mt-4 mb-2 row w-100" style={{ position: 'absolute', bottom: '0' }}>
          <div className="col" />
          <div className="d-flex align-items-end mr-3">
            {prUser.favoriteable_id && (
              <FavoriteButton
                favoriteableId={prUser.favoriteable_id}
                favoriteableType="PrUser"
                favoriteId={prUser.favorite_id}
                favorited={prUser.favorited}
                ahoyObjectGid={prUser.object_gid}
              />
            )}
            {prUser.user && mayStartConversations() && (
              <div className="ms-3 p-0 m-0">
                {v2MessagingEnabled ? (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => setDmModalOpen(true)}
                  >
                    <i className="float-left fa fa-paper-plane text-white" />
                    <span className="ms-2">Message {prUser.user.first_name}</span>
                  </button>
                ) : (
                  <a className="btn btn-sm btn-primary" href={`/users/${prUser.user.slug}/dm/new`}>
                    <i className="float-left fa fa-paper-plane text-white" />
                    <span className="ms-2">Message {prUser.user.first_name}</span>
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {v2MessagingEnabled && prUser.user && (
        <PeerDmModal
          isOpen={dmModalOpen}
          onClose={() => setDmModalOpen(false)}
          peerUserId={prUser.user.id}
          peerFirstName={prUser.user.first_name}
          peerName={prUser.full_name}
          peerTitle={peerTitle}
          peerAvatarUrl={prUser.avatar_url}
          peerInitials={prUser.initials}
        />
      )}
    </div>
  );
}

PrUserCard.propTypes = {
  prUser: PropTypes.instanceOf(Object),
  updates: PropTypes.instanceOf(Object),
};

PrUserCard.defaultProps = {
  prUser: undefined,
  updates: undefined,
};

export default PrUserCard;
